import React, { useState, useEffect } from "react";
import styles from "../styles/TeacherResources.module.scss";
import AddNewModal from "./createResourceModal";
import ResourcePreviewModal from "./resourcePreviewModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getPdfData,
  getPdfList,
  getResource,
} from "../../../../Redux/resource/resource.action";
import Loader from "../../../../utils/loader/loader";
import { BOARD_OPTIONS, SUBJECT_OPTIONS } from "../../../../utils/subjectBoard";
import { BASE_IMAGE_URL, DELETE_RESOURCE } from "../../../../utils/api";
import ToastMessage from "../../../../utils/toasts/toastMessage";
import DeleteConfirmModal from "../../../common/deleteConfirmModal/deleteConfirmModal";
import { apiRequest } from "../../../../api/apiRequest";

const resourcesMock = Array.from({ length: 12 }).map((_, i) => ({
  id: `res-${i + 1}`,
  title: [
    "Let's Celebrate our Books",
    "Best Novel Book",
    "Snow at Sunset",
    "Fiction Finds",
  ][i % 4],
  author: ["Maya Priya", "Mark Riley", "Paul James", "Ritu Mehta"][i % 4],
  thumb:
    "https://e7.pngegg.com/pngimages/166/194/png-clipart-nuclear-physics-nuclear-power-textbook-physics-book-cover-text-author-thumbnail.png",
  fileType: "image",
  fileUrl: null,
  fileName: null,
}));

export default function TeacherResources() {
  const dispatch = useDispatch();
  const [query, setQuery] = useState("");
  const [filterOpen, setFilterOpen] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [previewRes, setPreviewRes] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [selectedType, setSelectedType] = useState("");
  const [showAllRecommended, setShowAllRecommended] = useState(false);
  const [showAllPopular, setShowAllPopular] = useState(false);
  const [resources, setResources] = useState(resourcesMock);
  const [resourcesUrl, setResourcesUrl] = useState([]);
  const [resourcesData, setResourcesData] = useState([]);
  const [pdfUrl, setPdfUrl] = useState("");

  const [selectedIds, setSelectedIds] = useState([]);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
     const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });

  const tags = [];

  const store = useSelector((state) => state);
  const resourceUrlStore = useSelector(
    (state) => state?.ResourceManager?.pdfList,
  );
  const resourceDataStore = useSelector(
    (state) => state?.ResourceManager?.pdfMetaData,
  );

  useEffect(() => {
    dispatch(getPdfData());
    dispatch(getPdfList());
  }, [dispatch]);

  useEffect(() => {
    if (resourceUrlStore && resourceDataStore) {
      setLoading(false);
      setResourcesUrl(resourceUrlStore);
      setResourcesData(resourceDataStore);
    } else {
      setLoading(true);
    }
  }, [resourceUrlStore, resourceDataStore]);

  const handleAddResource = (res) => {
    setResources((prev) => [res, ...prev]);
  };

  const toggleSelect = (materialId) => {
  setSelectedIds((prev) =>
    prev.includes(materialId)
      ? prev.filter((x) => x !== materialId)
      : [...prev, materialId],
  );
};
  
const handleDeleteConfirmed = async () => {
  setConfirmDeleteOpen(false);
  setLoading(true);
  const result = await apiRequest("delete", DELETE_RESOURCE, null, {
    data: { material_ids: selectedIds },
  });

  if (!result.success) {
    setToastState({
      show: true,
      message: result.message || `Delete failed with status ${result.status}`,
      type: "error",
    });
    setLoading(false);
    return;
  }

  setResourcesData((prev) =>
    prev.filter((r) => !selectedIds.includes(r.material_id)),
  );

  dispatch(getPdfData());
  dispatch(getPdfList());

  setSelectedIds([]);
  setToastState({
    show: true,
    message: "Resources deleted successfully",
    type: "success",
  });

  setLoading(false);
};

const displayed = resources.filter((r) => {
    if (!query) return true;
    const q = query.toLowerCase();
    return (
      (r.title && r.title.toLowerCase().includes(q)) ||
      (r.author && r.author.toLowerCase().includes(q))
    );
  });

  const filteredRecommended = (resourcesData || []).filter((r) => {
    if (!query) return true;
    const q = query.toLowerCase();
    return (
      r?.subject?.toLowerCase().includes(q) ||
      r?.chapter?.toLowerCase().includes(q)
    );
  });

  const onCardClick = (e, r) => {
    e.preventDefault();
    const getUrl = resourcesUrl?.find((a) => a?.id === r.material_id);
    setPdfUrl(getUrl?.url);
    setPreviewRes(r);

    setPreviewOpen(true);
  };

  const handleClose = () => setAddOpen(false);

  const allRecommendedIds = filteredRecommended.map((r) => r.material_id);
const allSelected =
  allRecommendedIds.length > 0 &&
  allRecommendedIds.every((id) => selectedIds.includes(id));

const toggleSelectAll = () => {
  setSelectedIds((prev) =>
    allSelected
      ? prev.filter((id) => !allRecommendedIds.includes(id))
      : [...new Set([...prev, ...allRecommendedIds])],
  );
};

  return (
    <div className={styles.container}>
      <main className={styles.main}>
        <div className={styles.resourceTitle}>Resource</div>
        <div className={styles.resourceBar}>

          <div className={styles.tags}>
            {tags.map((t) => (
              <button
                className={`${styles.tag} ${
                  selectedType === t ? styles.activeTag : ""
                }`}
                key={t}
                onClick={() => setSelectedType(t)}
              >
                {t}
              </button>
            ))}
          </div>

          <div className={styles.resourceSearch}>
            <span className={styles.searchIcon}>🔍</span>
            <input
              className={styles.searchInput}
              placeholder="Find the resource you need"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>

          <button
            className={styles.primaryBtn}
            onClick={() => setAddOpen(true)}
          >
            <span style={{ marginRight: 8, fontWeight: 700 }}>+</span> Add New
          </button>
        </div>

        <AddNewModal
          open={addOpen}
          onClose={handleClose}
          selectedType={selectedType}
          onAddResource={handleAddResource}
        />
        <ResourcePreviewModal
          pdfUrl={pdfUrl}
          resource={previewRes}
          open={previewOpen}
          onClose={() => setPreviewOpen(false)}
        />

        {/* Recommended */}
        <section className={styles.sectionBox}>
          <div className={styles.sectionHeader}>
            <h3>Recommended</h3>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                width: "100%",
                justifyContent: "flex-end",
              }}
            >
              {/* <button
                className={styles.ghostBtn}
                onClick={() => setShowAllRecommended((v) => !v)}
              >
                {showAllRecommended ? "Show Less" : "See all"}
              </button> */}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  marginLeft: "auto",
                  marginBottom: "10px",
                }}
              >
                {filteredRecommended.length > 0 && (
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={allSelected}
                      onChange={toggleSelectAll}
                      style={{ width: "18px", height: "18px" }}
                    />
                    Select All
                  </label>
                )}
                {selectedIds.length > 0 && (
                  <button
                    className={styles.ghostBtn}
                    style={{
                      background: "#e53935",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      padding: "6px 12px",
                      cursor: "pointer",
                    }}
                    onClick={() => setConfirmDeleteOpen(true)}
                  >
                    Delete ({selectedIds.length})
                  </button>
                )}
              </div>
            </div>
          </div>

          {showAllRecommended ? (
            <div className={styles.booksGridCompact}>
              {filteredRecommended?.length > 0 ? (
                filteredRecommended.map((r) => (
                  <article
                    key={r.id}
                    onClick={(e) => onCardClick(e, r)}
                    className={styles.bookCard}
                  >
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(r.id)}
                      onClick={(e) => e.stopPropagation()}
                      onChange={() => toggleSelect(r.id)}
                      style={{
                        position: "absolute",
                        top: "8px",
                        right: "8px",
                        zIndex: 2,
                        width: "18px",
                        height: "18px",
                      }}
                    />
                    <div className={styles.thumb}>
                      <img
                        src={
                          r?.cover_image_url !== null
                            ? `${BASE_IMAGE_URL}${r?.cover_image_url}`
                            : "https://e7.pngegg.com/pngimages/166/194/png-clipart-nuclear-physics-nuclear-power-textbook-physics-book-cover-text-author-thumbnail.png"
                        }
                        alt={r?.chapter}
                      />
                    </div>
                    <div className={styles.title}>
                      {r?.subject?.toUpperCase()}
                    </div>
                    <div className={styles.meta}>Chapter: {r?.chapter}</div>
                  </article>
                ))
              ) : (
                <div>No Resource available.</div>
              )}
            </div>
          ) : (
            <div
              style={{
                overflowX: "auto",
                overflowY: "hidden",
                width: "100%",
                height: "340px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "16px",
                  width: "max-content",
                  height: "100%",
                  padding: "10px 0",
                  scrollBehavior: "smooth",
                }}
              >
                {filteredRecommended?.length > 0 ? (
                  filteredRecommended.map((r) => (
                    <article
                      key={r.id}
                      onClick={(e) => onCardClick(e, r)}
                      className={styles.bookCard}
                      style={{ position: "relative" }}
                    >
                      <input
                        type="checkbox"
                        checked={selectedIds.includes(r.material_id)}
                        onClick={(e) => e.stopPropagation()}
                        onChange={() => toggleSelect(r.material_id)}
                        style={{
                          position: "absolute",
                          top: "8px",
                          right: "8px",
                          zIndex: 2,
                          width: "18px",
                          height: "18px",
                        }}
                      />
                      <div className={styles.thumb}>
                        <img
                          src={
                            r?.cover_image_url !== null
                              ? `${BASE_IMAGE_URL}${r?.cover_image_url}`
                              : "https://e7.pngegg.com/pngimages/166/194/png-clipart-nuclear-physics-nuclear-power-textbook-physics-book-cover-text-author-thumbnail.png"
                          }
                          alt={r?.chapter}
                        />
                      </div>
                      <div className={styles.title}>
                        {r?.subject?.toUpperCase()}
                      </div>
                      <div className={styles.meta}>Chapter: {r?.chapter}</div>
                    </article>
                  ))
                ) : (
                  <div>No Resource available.</div>
                )}
              </div>
            </div>
          )}
        </section>
        {/* Popular Now */}
        <section className={styles.sectionBox}>
          <div className={styles.sectionHeader}>
            <h3>Popular Now</h3>
            <button
              className={styles.ghostBtn}
              onClick={() => setShowAllPopular((v) => !v)}
            >
              {showAllPopular ? "Show Less" : "all resources"}
            </button>
          </div>

          <div className={styles.booksGrid}>
            {(showAllPopular ? displayed : displayed.slice(0, 10)).map((r) => (
              <article
                key={r.id}
                className={styles.bookCard}
                onClick={(e) => onCardClick(e, r)}
                style={{ cursor: "pointer" }}
              >
                <div className={styles.thumb}>
                  <img src={r.thumb} alt={r.title} />
                </div>
                <div className={styles.title}>{r.title}</div>
                <div className={styles.meta}>{r.author}</div>
              </article>
            ))}
          </div>
        </section>

        <footer className={styles.footer}>
          © {new Date().getFullYear()} JIGYASSU
        </footer>
        <ToastMessage
          show={toastState.show}
          onClose={() => setToastState({ show: false, message: "", type: "" })}
          message={toastState.message}
          type={toastState.type}
        />
      </main>
      <Loader show={loading} />
      <DeleteConfirmModal
        show={!!confirmDeleteOpen}
        message={`Are you sure you want to delete ${selectedIds.length} resource(s)?`}
        loading={loading}
        onCancel={() => setConfirmDeleteOpen(false)}
        onConfirm={handleDeleteConfirmed}
      />
    </div>
  );
}
